<script>
  import { overlayContent } from '/stores.js';
  import { _ } from 'svelte-i18n'

  export let zIndex

  let refused = false

  function onClick() {
    $overlayContent = null
  }

  $: {
    refused = String($overlayContent).indexOf("REFUSAL") !== -1
    //console.log($overlayContent, refused)
  }

</script>

{#if $overlayContent }
  <div class="overlay" style="--zIndex: {zIndex};" on:click={onClick} class:refused>

    <div class="result">
      { $overlayContent }
    </div>

    <aside class="credits">
      <br />
      <a href={$_("artwork.queer_motto.overlay_url")} target="_blank">
        {$_("artwork.queer_motto.overlay_title")}
      </a>
    </aside>

  </div>
{/if}

<style lang="scss">
  .overlay {
    position: fixed;
    z-index: var(--zIndex);
    top:0;
    left:0;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: $color-mint;
    color: $color-red;
    font-family: 'Roboto Mono', monospace;
    &.refused {
      background-color: $color-red;
      color: $color-mint;
      padding: 0 15%;
    }

    a {
      text-decoration: underline;
      display: block;
    }
    &:not(.refused) a {
      padding: 0 15%;
    }
    
  }


  .result {
    white-space: pre-wrap;
    text-align: center;
  }

  .credits {
    text-align: center;
    width: 100%;
  }

</style>